import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Browsers will display a broke image icon if there is a error loading the image
 * A default image must be swap in the src attribute to prevent a broken image link.
 *
 * Changes the status of onError and swaps out the product image with a default image.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const CarouselImage = props => {
	const { src, alt } = props;

	const [source, setSource] = useState(src);
	const [error, setError] = useState(false);
	const defaultImage = 'https://media1.shmoop.com/images/homepage/default_wide_thumbnail-270x113.jpg';

	const onError = () => {
		if (!error) {
			setSource(defaultImage);
			setError(true);
		}
	};

	return  <img alt={alt} src={source} onError={onError} />;
};

CarouselImage.propTypes = {
	src: PropTypes.string,
	alt: PropTypes.string
};

export default CarouselImage;
